import React, { FC } from 'react'
import { useTranslation } from 'react-i18next';
import FormPanel from 'components/FormPanel';
import FormButtons from 'components/FormButtons';
import useFqdn from '../../hooks/useFqdn'

export const FqdnViewHeader: FC = () => {
    const { t } = useTranslation()
    const { selectedItem, goToListFqdnPage, goToEditSelectedFqdnPage } = useFqdn()

    return (
      <div>
        <FormPanel title={t('fqdn.grid.viewItemTitle')}>
          <FormButtons
            isEditing={false}
            onClickEdit={goToEditSelectedFqdnPage}
            onClickClose={goToListFqdnPage}
          />

        </FormPanel>
        <p>
          {t('fqdn.grid.domainGroup')}
          <span style={{ color: '#DE4343' }}>*</span>
        </p>
        <p className="read-only">
          <span style={{ paddingLeft: '.5rem' }}>{selectedItem?.fsId}</span>
        </p>
      </div>
    )
}

export default FqdnViewHeader;
